import { DarwinCollapse, DarwinCol } from 'components/darwin-ui';
import type { CollapseProps } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { IconName } from 'components/darwin-ui/Icon';
import { CollapseItem } from '../../dataTables/CollapseItem';
import { Process, ProcessCategory } from 'types/processesTypes';
import styles from './ProcessMap.module.css';

type SidebarProcessMapProps = {
  categories: ProcessCategory[];
  onProcessClick: (process: Process) => void;
};

export const SidebarProcessMap = ({
  categories,
  onProcessClick,
}: SidebarProcessMapProps) => {
  const items: CollapseProps['items'] = categories.map(
    ({ categoryName, processes, icon }, index) => {
      return {
        key: index,
        label: (
          <CollapseItem icon={icon as IconName} label={categoryName} isHeader />
        ),
        children: (
          <DarwinCol style={{ marginBottom: 0 }}>
            {processes &&
              processes.length > 0 &&
              processes.map(process => (
                <div
                  key={process.id}
                  draggable
                  onDragStart={event => {
                    event.dataTransfer.setData(
                      'application/reactflow',
                      JSON.stringify(process)
                    );
                    event.dataTransfer.effectAllowed = 'move';
                  }}
                  className={styles.draggableItem}
                >
                  <CollapseItem
                    icon={process.icon as IconName}
                    label={process.name}
                    onClick={() => onProcessClick(process)}
                  />
                </div>
              ))}
          </DarwinCol>
        ),
      };
    }
  );

  return (
    <DarwinCollapse
      accordion
      bordered={false}
      items={items}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined
          style={
            isActive
              ? { color: 'var(--primary-color)' }
              : { color: 'var(--gray-3-color)' }
          }
          rotate={isActive ? 270 : 90}
        />
      )}
      className={styles.menuSideBar}
      expandIconPosition="end"
      defaultActiveKey={[0]}
    />
  );
};
